import React from "react";

class InnerHeader extends React.Component {
    render() {
        return(
            <div className="InnerHeaderParent">
                <div className={"InnerHeader InnerHeaderText " + this.props.CustomClass} data-aos="fade-in" data-aos-offset="200" data-aos-delay="50" data-aos-easing="ease-in-out" data-aos-mirror="true" style={{backgroundImage: `url(${this.props.imageurl})`, backgroundPosition: `right`, backgroundSize: `contain`, backgroundRepeat: `no-repeat`, height: `600px`}}>
                    <div className="container h-100">
                        <div className="row h-100 align-items-center justify-content-start">
                            {this.props.pagedesc ?
                            <div className="col-xl-6">
                                <h1 className="d-none d-sm-block" data-aos="fade-up" dangerouslySetInnerHTML={{
                                    __html: this.props.pagename
                                }}>
                                </h1>
                                <div className="pagedescInnerHeader pagedescInnerHeaderMargin mt-4" dangerouslySetInnerHTML={{
                                    __html: this.props.pagedesc
                                }}></div>
                            </div>
                            : 
                            <div className="col-xl-12">
                                <h1 className="d-none d-sm-block" data-aos="fade-up" dangerouslySetInnerHTML={{
                                    __html: this.props.pagename
                                }}>
                                </h1>
                            </div>
                            }
                        </div>
                    </div>
                </div>
                <div className="d-block d-sm-none InnerHeaderText">
                    <h1 data-aos="fade-up" dangerouslySetInnerHTML={{
                        __html: this.props.pagename
                    }}>
                    </h1>
                    <div className="pagedescInnerHeader mt-4" dangerouslySetInnerHTML={{
                        __html: this.props.pagedesc
                    }}></div>
                </div>
            </div>
        );
    }
}

export default InnerHeader;